import axios from "../axiosInstance";
import {
  SubmitChapterActivityRequest,
  SubmitChapterActivityResponse,
} from "./types";

export const submitChapterActivity = async (
  activityData: SubmitChapterActivityRequest,
): Promise<SubmitChapterActivityResponse> => {
  const response = await axios.post<SubmitChapterActivityResponse>(
    "/api/private/chapter-activity/submit",
    activityData,
  );
  return response.data;
};
